import { useEffect, useState } from "react";
import Cookies from "js-cookie";
const auth_service = require("../helpers/authService");
const admin_service = require("../helpers/admin_service");

const removeCookieAndRedirect = () => {
  Cookies.remove(process.env.REACT_APP_COOKIE_KEY, {
    domain: process.env.REACT_APP_DOMAIN,
  });
  window.location.href = process.env.REACT_APP_REDIRECT_ENDPOINT;
};

export default function useDataUsr() {
  const [dataUsr, setDataUsr] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let jwt;
    try {
      const raw = Cookies.get(process.env.REACT_APP_COOKIE_KEY);
      jwt = raw ? JSON.parse(raw) : null;
    } catch (e) {
      jwt = null;
    }

    if (!jwt || !jwt.TokenType || !jwt.accessToken) {
      removeCookieAndRedirect();
      return;
    }

    (async function () {
      try {
        setLoading(true);
        auth_service
          .getDataAuth("/usr/get-usr", jwt.TokenType, jwt.accessToken)
          .then((data) => {
            if (
              data.data.cognito.permisos == "COMERCIAL" ||
              data.data.cognito.permisos == "REDES SOCIALES"
            ) {
              admin_service
                .getDataAuth(
                  "/asesor/view_sub/" + data.data.cognito.sub,
                  jwt.TokenType,
                  jwt.accessToken
                )
                .then((response) => {
                  let info = data.data.cognito;
                  info.asesor_id = response.data.response.result[0].UniqueID;
                  info.asesor_hash = response.data.response.result[0].hash;
                  setDataUsr(info);
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              setDataUsr(data.data.cognito);
            }
          })
          .catch((err) => {
            removeCookieAndRedirect();
            console.log(err);
          });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { dataUsr, error, loading };
}
